function Auth() {
  return <dialog>
    <h1>Auth</h1>

    <label htmlFor="">
      <span></span>
      <input type="text"/>
    </label>

    <label htmlFor="">
      <span></span>
      <input type="text"/>
    </label>

    <label htmlFor="">
      <span></span>
      <input type="text"/>
    </label>

    <button>Cancel</button>
    <button>Submit</button>

  </dialog>
}

export default Auth